import map from 'lodash/map.js';

import Model from '@/models/Model.js';

export default class PageViewGroup extends Model {
    static entity = 'page_view_group';

    static primaryKey = ['page_id', 'group_id'];

    static fields() {
        return {
            id: this.attr(null),
            page_id: this.attr(null),
            group_id: this.attr(null),

            created_by: this.attr(null),
            updated_by: this.attr(null),
            deleted_by: this.attr(null),

            created_at: this.string(''),
            updated_at: this.string(''),
            deleted_at: this.string(''),
        };
    }

    static async syncGroups(model) {
        const endpoint = `api/pages/${model.slug}/groups`;

        const currentGroupIds = map(model.view_groups, 'id');

        await this.store().dispatch('AutoSave/setSaving', 'entities/page_view_group');

        const response = await this.api().put(
            endpoint,
            {
                groups: currentGroupIds,
            },
            {
                dataTransformer: () => {
                    return currentGroupIds.map(id => ({
                        page_id: model.id,
                        group_id: id,
                    }));
                },
                save: false,
            }
        );

        await PageViewGroup.deleteAll();

        response.save();

        await this.store().dispatch('AutoSave/setSaved', 'entities/page_group');

        return response.response.data;
    }
}
